import { render } from "./HeadIcon.vue?vue&type=template&id=e27e334a"
import script from "./HeadIcon.vue?vue&type=script&lang=js"
export * from "./HeadIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__